<script lang="ts">
  import { Col, Image } from "sveltestrap";
  import Card from "../../../Core/Card.svelte";
  import { Blogpara, Blogpara2, WhyChoose } from "../../../../utils/Constant/Constant";
  let imgPath:string = "/assets/images/knowledgebase"

</script>
<Col xl="9" class="xl-60 box-col-8">                        
    <div class="blog-single">
      <div class="blog-box">
        <div class="card">
          <Image fluid class="w-100" src="{imgPath}/1.jpg" alt="blog-main" />
        </div>
        <Card>
          <div slot="contentbody">
            <div class="blog-details">                                  
              <h4 class="mt-0">{WhyChoose}</h4>
              <div class="single-blog-content-top">
                <p>{Blogpara}</p>
                <p>{Blogpara2}</p>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
</Col>